const convertFirestoreDate = (firestoreDate) => {
  // eslint-disable-next-line no-underscore-dangle
  return new Date(firestoreDate._seconds * 1000).toLocaleDateString('en-US');
};

export default convertFirestoreDate;
